<div class="noDataWrapper">
  <!-- <ion-icon name="warning-outline" aria-label="No data found"></ion-icon> -->
  <ion-icon name="document-outline" aria-label="No data found" class="no-data-icon"></ion-icon>
  <!-- alt="No Trusted Devices Icon"></ion-img> -->
  <h3 class="no-data-title" *ngIf="title">
    {{title}}
  </h3>
  <p class="noDataText" *ngIf="message">
    {{ message }}
  </p>
</div>